var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{attrs:{"inline":""}},[_c('b-form-select',{attrs:{"size":_vm.size,"options":_vm.limits,"disabled":_vm.disabled,"value":_vm.value},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }